import { getDefaultNodeImage, getNodeImage, getNodeName } from "Areas/SharedFeatures/nodeLabel";
import { NODE_MIN_SIZE } from "../../constants";
export default (nodeSource, documentObjects) => {
    const documentObject = nodeSource.DocumentObject ||
        (documentObjects ? documentObjects[nodeSource.DocumentObjectId] : undefined);
    const attributeValues = nodeSource.AttributeValues || [];
    const nodeImage = getNodeImage(attributeValues, documentObject, true);
    const defaultNodeImage = getDefaultNodeImage(documentObject);
    return {
        ...nodeSource,
        DocumentObject: documentObject,
        NodeImage: nodeImage,
        NodeDefaultImage: defaultNodeImage !== nodeImage ? defaultNodeImage : "",
        NodeName: getNodeName(attributeValues, documentObject),
        AttributeValues: attributeValues,
        PinnedToGroup: Boolean(nodeSource.GroupId && nodeSource.PinnedToGroup),
        NodeHeight: Math.max(nodeSource.NodeHeight || 0, NODE_MIN_SIZE.height),
        NodeWidth: Math.max(nodeSource.NodeWidth || 0, NODE_MIN_SIZE.width),
        InputLinksCount: nodeSource.InputLinksCount,
        OutputLinksCount: nodeSource.OutputLinksCount
    };
};
